import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import {
  FileUpload,
  PresignedUrlResult,
  ServiceCallInfo,
} from "../models/common";
import { take, map, catchError } from "rxjs/operators";
import { ValidationPipe } from "../components/ui/validation.pipe";
import { Order, OrderFile } from "../models/order.model";
import { ServiceOptions } from "../models/service-options";
import { Store } from "@ngrx/store";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  fileInvalidAlert: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private readonly store: Store,
    private validationPipe: ValidationPipe
  ) {}

  public uploadFile(fileData: File): Promise<string | ArrayBuffer> {
    const reader = new FileReader();
    const file: File = fileData;
    reader.readAsDataURL(file);
    return new Promise((resolve) => {
      reader.addEventListener("load", (event: any) => {
        resolve(reader.result);
      });
    });
  }

  public getPresignedUrl(
    fileData: FileUpload,
    publicReadSw: boolean = true
  ): Observable<PresignedUrlResult> {
    var serviceName = "brosh.GetPresignedUrl";
    let response = new Observable<PresignedUrlResult>();
    let params = new ServiceOptions();
    params.serviceName = serviceName;
    params["subFolder"] = fileData.subFolder;
    params["filePrefix"] = fileData.fileType;
    params["username"] = this.authService.currentUser.username;
    params["publicReadSw"] = publicReadSw ? "1" : "0";

    let url = this.authService.getRequestUrl(serviceName, true);
    let body = this.authService.getRequestBody(params);
    let info = new ServiceCallInfo("getPresignedUrl", url, body);
    response = this.http
      .post(url, body, {
        headers: this.authService.getRequestHeaders(),
        withCredentials: false,
        responseType: "json",
      })
      .pipe(
        take(1),
        map((rep: any) => {
          this.authService.extractRequestStatusNew(info, rep);
          let data = rep.reply.data;
          fileData.fileUuid = data.uuid;
          let res = new PresignedUrlResult();
          res.uploadUrl = data.url;
          res.s3Key = data.s3Key;
          return res;
        }),
        catchError((error) => {
          return this.authService.handleErrorNew(error, info);
        })
      );

    return response;
  }

  public copyUploadFile(s3Key: string): Observable<boolean> {
    var serviceName = "brosh.CopyUploadFile";
    let response = new Observable<boolean>();
    let params = new ServiceOptions();
    params.serviceName = serviceName;
    params["s3Key"] = s3Key;

    let url = this.authService.getRequestUrl(serviceName, true);
    let body = this.authService.getRequestBody(params);
    let info = new ServiceCallInfo(serviceName, url, body, false);
    response = this.http
      .post(url, body, {
        headers: this.authService.getRequestHeaders(),
        withCredentials: false,
        responseType: "json",
      })
      .pipe(
        take(1),
        map((rep: any) => {
          return this.authService.extractRequestStatusNew(info, rep);
        }),
        catchError((error) => {
          return this.authService.handleErrorNew(error, info);
        })
      );

    return response;
  }

  public putFile(file: FileUpload, url: string): Observable<any> {
    return this.http.put(url, file.file);
  }

  public validateFile(fileData: File, validationStr?: string): boolean {
    let fileName = fileData.name.toLowerCase();
    let fileType = fileName.split(".")[fileName.split(".").length - 1];

    let isValidFileType: boolean;
    if (validationStr) {
      isValidFileType = validationStr.indexOf(fileType) !== -1;
    } else {
      isValidFileType = "jpg,jpeg,png".indexOf(fileType) !== -1;
    }
    if (!isValidFileType) {
      this.fileInvalidAlert = "translate.validation.pdfOrJpgOnly";
      return false;
    }
    this.fileInvalidAlert = "";
    return true;
  }

  public getFileType(fileData: File): string {
    if (!fileData) return "";
    return (
      "." +
      fileData.name
        .split(".")
        [fileData.name.split(".").length - 1].toLowerCase()
    );
  }

  public uploadFileToAlgService(
    fileData: FileUpload,
    order: Order,
    orderFile: OrderFile = null
  ): Observable<any> {
    let response = new Observable<any>();
    let serviceName = "UploadOrderAttach.do";
    let params = {};
    params["originApp"] = "brosh_on_line";
    params["serviceName"] = serviceName;
    params["urldecodeSw"] = 0;
    params["username"] = this.authService.currentUser.username;
    params["data"] = {};
    params["data"]["orderNumMeimad"] = order.orderIdMmd;
    params["data"]["orderAttachFileName"] = fileData.file.name.toLowerCase();
    params["data"]["orderAttachFileExt"] = fileData.fileType;
    params["data"]["orderAttachBase64"] = fileData.base64;

    let req = {};
    req["request"] = params;

    console.log(req);
    let url = this.authService.getRequestUrl(serviceName, true);
    let body = JSON.stringify(req);
    let info = new ServiceCallInfo("UploadOrderAttach.do", url, body, true);
    response = this.http
      .post(url, body, {
        headers: this.authService.getRequestHeaders(),
        withCredentials: false,
        responseType: "json",
      })
      .pipe(
        take(1),
        map((data) => {
          this.authService.extractRequestStatusNew(info, data);
          console.log(data);
          let dataRep = data as any;
          fileData.fileUuid = (dataRep.orderAttachS3Key as string)
            .replace(fileData.subFolder + "/", "")
            .replace(fileData.fileType, "");
          if (orderFile) orderFile.url = dataRep.orderAttachUrl;
        }),
        catchError((error) => {
          return this.authService.handleErrorNew(
            "Error uploading file. Please contact support.",
            info
          );
        })
      );

    return response;
  }
}
